import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AvtListesComponent } from '../avt-listes/avt-listes.component';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { AvtSuiviePedNoteComponent } from '../avt-suivie-ped-note/avt-suivie-ped-note.component';

@Component({
  selector: 'app-avt-liste-evaluations',
  templateUrl: './avt-liste-evaluations.component.html',
  styleUrls: ['./avt-liste-evaluations.component.scss']
})
export class AvtListeEvaluationsComponent implements OnInit, AfterViewInit
{

  constructor(
    public generalService:GeneralService,
    public route: ActivatedRoute,
    public router:Router,
    public dialog: MatDialog) {}
 
  exist : boolean = true;
  disabled : boolean = false;
  showListeEvaluations : boolean = false;
  annee : string;
  listeAnnee = [];
  param_code : string;
  fenetre : string;
  @ViewChild("listeEvaluationComponen", {static : false}) listeEvaluationComponen : AvtListesComponent;
  columnsEvaluation;
  title : string = "";
  showListeEvaluation : boolean = false;

  ngAfterViewInit()
  {
    this.readParamUrl()
  }
  ngOnInit() 
  {
    this.columnsEvaluation = {TableRD:[""]}
    this.setAnnee();
  }
  onAnneeChange()
  {

  }
  ajouterEvaluation()
  {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    var dialogRef = this.dialog.open(AvtSuiviePedNoteComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result =>
    {
    });
  }
  showEvaluation()
  {

  }
  setAnnee()
  {
    for(var i=0;i<10;i++)
    {
      this.listeAnnee.push(((new Date()).getFullYear()-i).toString())
    }
  }
  init()
  {
    this.showListeEvaluation = false;
    var url = this.generateUrl();
    this.getListeEvaluation(url)
  }
  setTitle()
  {
    //fenetre == 0 =>liste evaluation
    if(this.fenetre == "0")
    {
      this.title = "LISTE ÉVALUATIONS"
      
    }
    //fenetre == 1 =>liste evaluation par Groupe 
    else if(this.fenetre == "1")
    {
      this.title = "ÉVALUATIONS GROUPE"
    }
    //fenetre == 2 =>detail evaluation par Groupe (liste des note pour chaque apprenant)
    else if(this.fenetre == "2")
    {
      this.title = "GROUPE"
    }
    
  }
  generateUrl() : string
  {
    var url : string = "test"
    //fenetre == 0 =>liste evaluation
    if(this.fenetre == "0")
    {
      if(this.param_code != "-1")
      {
        url+= "&param=" + this.param_code;
      }
    }
    //fenetre == 1 =>liste evaluation par Groupe 
    else if(this.fenetre == "1")
    {
      
    }
    //fenetre == 2 =>detail evaluation par Groupe (liste des note pour chaque apprenant)
    else if(this.fenetre == "2")
    {
      
    }
    return url
  }
  getListeEvaluation(url)
  {   
    setTimeout(() => 
      {
      //fenetre == 0 =>liste evaluation
      if(this.fenetre == "0")
      {
        var listeEvaluations;
        listeEvaluations = [{dateEvaluation :"2020",groupeEvaluation:"G1", cursusEvaluation:"Lisence Info", formateurEvaluation : "Mohamed"}]
      }
      //fenetre == 1 =>liste evaluation par groupe
      else if(this.fenetre == "1")
      {
        listeEvaluations = [{dateEvaluation :"2020",effectifEvaluation:"5", matieresEvaluation:"algorithme", minEvaluation : "5",moyenneEvaluation :"14",maxEvaluation:"20", coeffEvaluation:"1",}]

      }
      //fenetre == 2 =>detail evaluation par Groupe (liste des note pour chaque apprenant)
      else if(this.fenetre == "2")
      {
        //apprenantsNoteEvaluation noteEvaluation oldNoteEvaluation CommentaireNoteEvaluation
        listeEvaluations = [{apprenantsNoteEvaluation :"<img src='../../assets/avatar.png' style='width : 60px;margin-right : 10px'> apprenant 1",noteEvaluation:"5", oldNoteEvaluation:"2", CommentaireNoteEvaluation : "commentaire 1"},
        {apprenantsNoteEvaluation :"<img src='../../assets/avatar.png' style='width : 60px;margin-right : 10px'> apprenant 1",noteEvaluation:"5", oldNoteEvaluation:"2", CommentaireNoteEvaluation : "commentaire 1"}]

      }
      this.generateColumnsEvaluation(listeEvaluations);
      this.showListeEvaluation = true; 
      setTimeout(() => 
      {
        this.setTitle()
        this.listeEvaluationComponen.setDataSource(listeEvaluations);
      }, 100);
    }, 100);
  }
  generateColumnsEvaluation(listeEvaluations)
  {
    var tabHref = [];
    var tabHref2 = [];
    //fenetre == 0 =>liste evaluation
    if(this.fenetre == "0")
    {
      listeEvaluations.forEach(row => 
      {
        tabHref.push({href:["/avt/liste/evaluations/-1/1"],row:row})
        if(this.param_code == "-1")
          tabHref2.push({href:["/avt/liste/evaluations/12/1"],row:row})
      });
      var typeColomneNum3 = 0
      if(this.param_code == "-1")
        typeColomneNum3 = 101
      this.columnsEvaluation =
      {
        "TableRD":
        [
          {"TableRE_Code":"","TableRD_Champs":"dateEvaluation","Lg_Code":"","TableRD_Des":"Date évaluation","TableRD_Largeur":150,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"groupeEvaluation","Lg_Code":"","TableRD_Des":"Groupes","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":101,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null,"tabHref": tabHref},
          {"TableRE_Code":"","TableRD_Champs":"cursusEvaluation","Lg_Code":"","TableRD_Des":"Cursus","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"formateurEvaluation","Lg_Code":"","TableRD_Des":"NOM et Prénom du formateur","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":typeColomneNum3,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null,"tabHref": tabHref2},
        ]
      }
    }
    //fenetre == 1 =>liste evaluation par Groupe 
    else if(this.fenetre == "1")
    {
      listeEvaluations.forEach(row => 
      {
        tabHref.push({href:["/avt/liste/evaluations/10/2"],row:row})
      });
      this.columnsEvaluation =
      {
        "TableRD":
        [
          {"TableRE_Code":"","TableRD_Champs":"dateEvaluation","Lg_Code":"","TableRD_Des":"Date évaluation","TableRD_Largeur":150,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":101,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null,"tabHref": tabHref},
          {"TableRE_Code":"","TableRD_Champs":"effectifEvaluation","Lg_Code":"","TableRD_Des":"Effectif","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"matieresEvaluation","Lg_Code":"","TableRD_Des":"Matières/Modules","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"minEvaluation","Lg_Code":"","TableRD_Des":"Min","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"moyenneEvaluation","Lg_Code":"","TableRD_Des":"Moyenne","TableRD_Largeur":100,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"maxEvaluation","Lg_Code":"","TableRD_Des":"Max","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"coeffEvaluation","Lg_Code":"","TableRD_Des":"Coeff","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
        ]
      }
    }
    //fenetre == 2 =>detail evaluation par Groupe (liste des note pour chaque apprenant)
    else if(this.fenetre == "2")
    {
      this.columnsEvaluation =
      {
        "TableRD":
        [
          {"TableRE_Code":"","TableRD_Champs":"apprenantsNoteEvaluation","Lg_Code":"","TableRD_Des":"Apprenants","TableRD_Largeur":150,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":7,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null,"tabHref": tabHref},
          {"TableRE_Code":"","TableRD_Champs":"noteEvaluation","Lg_Code":"","TableRD_Des":"Notes","TableRD_Largeur":70,"TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"oldNoteEvaluation","Lg_Code":"","TableRD_Des":"Notes antérieures","TableRD_Largeur":70,"TableRD_ReadOnly":true,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":4,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":"number","TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
          {"TableRE_Code":"","TableRD_Champs":"CommentaireNoteEvaluation","Lg_Code":"","TableRD_Des":"Commentaire Evaluation","TableRD_Largeur":300,"TableRD_ReadOnly":false,"TableRD_Format":"","TableRD_Alligement":0,"TableRD_Ordre":5,"TableRD_Type":0,"TableRD_Param1":null,"TableRD_Param2":null,"TableRD_ValDef":null,"TableRD_Tri":true,"TableRD_Valid":null,"TableRD_ValidType":0,"TableRD_ExpressionH":null,"TableRD_ExpressionR":null,"User_Id":"*","User_Groupe":null},
        ]
      }
    }
  }
  readParamUrl()
  {
    this.route.params.subscribe(params => 
    {
      this.param_code = params['param_code'];
      this.fenetre = params['fenetre'];
      this.init()
    });
  }
}
